import {MOON_50, MOON_250} from '@wandb/weave/common/css/color.styles';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner, BannerBoldText} from '../../../Banner';

export const BannerWithMargin = styled(Banner)`
  margin: 8px 0;
`;
BannerWithMargin.displayName = 'S.BannerWithMargin';

export const PointerBoldText = styled(BannerBoldText)`
  cursor: pointer;
`;
PointerBoldText.displayName = 'S.PointerBoldText';

export const Panel = styled.div`
  display: flex;
  flex-direction: column;
  background-color: white;
  padding: 10px;
  border-radius: 4px;
  border: 1px solid ${MOON_250};
  margin-top: 16px;
  justify-content: center;
  ol {
    padding-left: 16px;
  }
`;
Panel.displayName = 'S.Panel';

export const Header = styled.div`
  display: flex;
  align-items: left;
  margin-bottom: 16px;
  font-weight: 600;
`;
Header.displayName = 'S.Header';

export const CodeSnippet = styled.div`
  width: 400px;
  padding: 8px;
  background-color: ${MOON_50};
  display: flex;
  flex-direction: column;
  margin: 16px -4px 12px -4px;
  border-radius: 4px;
`;
CodeSnippet.displayName = 'S.CodeSnippet';

export const CodeSnippetHeader = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-family: 'Source Sans Pro' !important;
  line-height: 24px;
  width: 100%;
`;
CodeSnippetHeader.displayName = 'S.CodeSnippetHeader';

export const Code = styled.code`
  flex: 1 1 auto;
  font-size: 12px;
  line-height: 15.08px;
  font-family: 'Source Code Pro';
  margin-top: 10px;
  white-space: pre-wrap;
`;
Code.displayName = 'S.Code';
